import type { Catalog } from '../catalog';
import { toAbilitySlug, toHeroSlug, toItemSlug } from './dotaNames';

export { getDotaDisplayName, toAbilitySlug, toDotaDisplayName, toHeroSlug, toItemSlug } from './dotaNames';
export { resolveHeroDisplayName, resolveAbilityDisplayName, resolveItemDisplayName } from './dotaNames';

// WebP-миниатюры из public/dota-thumbs (npm run thumbs). Каких нет — nginx отдаёт оригинал
// через прокси /dota-img (см. nginx.conf), так что URL всегда рабочий.
const DOTA_THUMBS_BASE = '/dota-thumbs';

const thumbUrl = (kind: 'heroes' | 'abilities' | 'items', slug: string) =>
  slug ? `${DOTA_THUMBS_BASE}/${kind}/${slug}.webp` : '';

export const getHeroImageUrl = (heroName?: string) => thumbUrl('heroes', toHeroSlug(heroName));

export const getAbilityImageUrl = (abilityName?: string) => thumbUrl('abilities', toAbilitySlug(abilityName));

export const getItemImageUrl = (itemName?: string) => thumbUrl('items', toItemSlug(itemName));

// ─── Catalog override helpers ─────────────────────────────────────────────────

/**
 * Prefer an override value; fall back when the override is null, undefined,
 * or a blank string (defensive against empty DB rows).
 */
const pickOverride = <T,>(override: T | null | undefined, fallback: T): T => {
  if (typeof override === 'string') return ((override as string).trim() ? override : fallback) as T;
  return override ?? fallback;
};

export const resolveHeroImageUrl = (catalog: Catalog, heroName?: string): string =>
  pickOverride(catalog.heroes[heroName ?? '']?.imageUrl, getHeroImageUrl(heroName));

export const resolveAbilityImageUrl = (catalog: Catalog, abilityName?: string): string =>
  pickOverride(catalog.abilities[abilityName ?? '']?.imageUrl, getAbilityImageUrl(abilityName));

export const resolveItemImageUrl = (catalog: Catalog, itemName?: string): string =>
  pickOverride(catalog.items[itemName ?? '']?.imageUrl, getItemImageUrl(itemName));
